import { CaregiverResponse } from "api";

import { UserInfoType } from "../../../components/views/userEdit/types";
import { careGiverRoleConverter } from "../roles";

export const careGiverErrorFieldConverter = (bioTField: string): string | undefined => {
  return {
    /* eslint-disable camelcase */
    "name.firstName": "firstName",
    "name.lastName": "lastName",
    email: "email",
    employeeId: "employeeId",
    role: "roleId",
    /* eslint-enable camelcase */
  }[bioTField];
};

export const careGiverConverter = (careGiver: CaregiverResponse) => {
  const role = careGiverRoleConverter(careGiver);
  return {
    id: careGiver._id,
    email: careGiver._email,
    firstName: careGiver._name.firstName,
    lastName: careGiver._name.lastName,
    employeeId: careGiver._employeeId,
    role,
    roleId: role.id || "admin",
    invitationAccepted: careGiver._invitationAccepted,
  };
};

export const careGiverReverseConverter = (user: UserInfoType, existingCareGiver?: CaregiverResponse) => {
  return {
    /* eslint-disable camelcase */
    _name: {
      firstName: user.firstName,
      lastName: user.lastName,
    },
    _employeeId: user.employeeId,
    ...(user.email !== existingCareGiver?._email ? { _email: user.email } : {}),
    // Admin's have no 'role' and we need to put a fake id here, otherwise yup will complain...
    ...(user.roleId !== "admin" && user.roleId !== existingCareGiver?.role ? { role: user.roleId } : {}),
    /* eslint-enable camelcase */
  };
};
